import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '../store'

// import { readymd5 } from '../assets/js/utils'
Vue.use(VueAxios, axios);
var instance = axios.create();
Vue.prototype.$axios = instance
instance.defaults.timeout = 60000;
// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  if (config.method == 'post') {
    // vm.$loading();
  }
  return config;
}, function (error) {
  // vm.$loading().close();
  vm.$message.error(vm.$t('interact.14'));
  return Promise.reject(error)
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  // vm.$loading().close();
  if (response.data.resCode === 'C502570000000' || response.data.resCode == 200) {
    return response;
  }
  if (response.data.resCode === 'E502576000008') {//用户未登录
    // console.error(response);
    store.commit('logout');//登出
    vm.$alert(vm.$t('interact.15'), {//登录超时请重新登录
      confirmButtonText: vm.$t('confirmText'),//'确定',
      callback: action => {
        vm.$router.push({ path: '/' });
        vm.$alert.close();
      }
    });
    return Promise.reject(response)
  } else {
    let errorMessage = 'interact.' + response.data.resCode == vm.$t('interact.' + response.data.resCode)?response.data.resMsg:vm.$t('interact.' + response.data.resCode)
    vm.$alert(errorMessage, {
      showClose: false,
      confirmButtonText: vm.$t('confirmText')
    });
    return Promise.reject(response)
  }
}, function (error) {
  // vm.$loading().close();
  vm.$message.error(vm.$t('interact.1'));
  return Promise.reject(error)
});
export default instance



// WEBPACK FOOTER //
// ./src/http/index.js